import { styled } from '@mui/material';

export const StyledPropertyColumn = styled('div')(({ theme }) => ({
  gap: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column'
}));
